import {get, kebabCase} from 'lodash';
import store from '../store';
import Message from './message.service';
import Events from './events.service';

const GitBus = {
  channel: null,
  messageListener: null
};

async function onMessage(data) {
  if (!(get(data, 'channel') === GitBus.channel)) return;
  Events.$emit('gitChange', data);
}

async function setup() {
  const gitMode = store.getters.getGitMode;
  const gitBranch = store.getters.getGitBranch;
  const account = store.getters.getAccount;
  if (!gitMode) return;
  GitBus.channel = `${account.guid}-${kebabCase(gitBranch)}`;
  GitBus.messageListener = {
    message: onMessage
  };
  await Message.subscribe(GitBus.channel, GitBus.messageListener, 'git-bus');
}

async function destroy() {
  if (GitBus.channel) await Message.unsubscribe(GitBus.channel, GitBus.messageListener, 'git-bus');
}

async function changeBranch() {
  await destroy();
  await setup();
}

Events.$on('gitBranchChanged', changeBranch);
export default {setup, destroy};
